module.exports = __webpack_public_path__ + "img/cont-01-salute.1af9f955.svg";